import React, { useState, useEffect } from "react";
import {Button, Row, Col, Badge, Card, Form, Container, CloseButton} from "react-bootstrap";
import { stats } from "../data/relics";
import { sets } from "../data/relics";

const RelicSelection = (props) => {

    const buildStat = (key, index) => {
        let prefix = stats[key].prefix;
        let suffix = stats[key].suffix;
        let value = props.selectedRelic.stats[props.selectedLevel][key];
        let text = prefix + ' ' + value + ' ' + suffix;
        return <Row key={index}><Col><Badge bg="primary" size="sm">{text}</Badge>{' '}</Col></Row>
    };

    const buildSetBonusStat = (sets, stats) => {
        if (!props.selectedRelic.set)
        {
            return <></>
        }

        let set = sets[props.selectedRelic.set];
        let setStats = set.stats;
        let key = Object.keys(setStats[props.selectedLevel])[0];
        let prefix = stats[key].prefix;
        let suffix = stats[key].suffix;
        let value = setStats[props.selectedLevel][key];
        let text = set.name + ' | ' + prefix + ' ' + value + ' ' + suffix;

        return <Row><Col><Badge bg="secondary" size="sm">{text}</Badge>{' '}</Col></Row>
    };

    const handleSelectLevel = (e) => {
        props.setSelectedLevel(e.target.value);
    };

    const handleEquip = () => {
        props.setReadyToEquip(true);
    };

    const handleRemove = () => {
        props.handleRemove();
    };

    return (
        <Card>
            <Card.Body className="selection">
                <Form>
                    <Row xs="auto">
                        <Col>
                            <Form.Label><h6>{props.selectedRelic.label}</h6></Form.Label>
                        </Col>
                        <Col>
                            {
                                props.selectedRelic.level 
                                ?
                                    <Form.Select disabled size={"sm"} value={props.selectedRelic.level}>
                                        {
                                            Object.keys(props.selectedRelic.stats).map((key) => {
                                                return <option key={key} value={key}>{key}</option>
                                            })
                                        }
                                    </Form.Select>
                                :
                                    <Form.Select size={"sm"} value={props.selectedLevel} onChange={handleSelectLevel}>
                                        {
                                            Object.keys(props.selectedRelic.stats).map((key) => {
                                                return <option key={key} value={key}>{key}</option>
                                            })
                                        }
                                    </Form.Select>
                            }
                        </Col>
                        <Col>
                            {
                                'Equip' === props.selectionButtonText
                                ? <Button variant="warning" size="sm" onClick={handleEquip}>{props.selectionButtonText}</Button>
                                : <Button variant="warning" size="sm" onClick={handleRemove}>{props.selectionButtonText}</Button>
                            }
                        </Col>
                        <Col>
                            <CloseButton onClick={() => props.setShowSelection(false)}/>
                        </Col>
                    </Row>
                </Form>
                <Row>
                    {
                        '' === props.selectedLevel
                        ?
                            <></>
                        :
                            <Col>
                                {
                                    Object.keys(props.selectedRelic.stats[props.selectedLevel]).map((key, index) => {
                                        return buildStat(key, index);
                                    })
                                }
                                { 
                                    buildSetBonusStat(sets, stats)
                                }
                            </Col>
                    }
                </Row>
            </Card.Body>
        </Card>
    );
};

export default RelicSelection;